import axios from 'axios'

const service = axios.create()
// service.defaults.baseURL = 'http://www.shrewin.cn/backAdmin/'
service.defaults.imgULR = 'http://192.168.1.113:8086/'
service.defaults.timeout = 8000
service.defaults.withCredentials = true
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
service.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'

// 请求拦截
service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/http/axios.js